import * as landRegistryActions from '../../../actions/landRegistry';
import i18nMixin from '../../i18nMixin';
import { coreActions, constants, coreStore } from '@ambita/ambita-components-core';
import { modalMixin } from '../../modalMixin';

function setOpenDirectlyFlag(openLookupDirectly: boolean) {
  if (openLookupDirectly) {
    coreActions.changeSettings(<any>{
      openLookupDirectly: true
    });
  }
}

export function init(tag) {
  tag.mixin(i18nMixin);
  tag.mixin(modalMixin);

  tag.closeModal = (event: Event) => {
    event.preventDefault();
    tag.unmount();
  };

  tag.addToCart = (event: Event) => {
    setOpenDirectlyFlag(tag.refs.oneClickAgreement.checked);
    landRegistryActions.addPantebokProduct(tag.opts.reference, tag.opts.product, tag.opts.orderData, tag.opts.rightKey);
    tag.closeModal(event);
  };

  tag.on('mount', () => {
    coreStore.on(constants.core.LOGOUT_EVENT, tag.closeModal);
  });

  tag.on('unmount', () => {
    coreStore.off(constants.core.LOGOUT_EVENT, tag.closeModal);
  });
}
